import { render } from "./SendMailCompletelyPage.vue?vue&type=template&id=47b17339&scoped=true"
import script from "./SendMailCompletelyPage.vue?vue&type=script&lang=ts"
export * from "./SendMailCompletelyPage.vue?vue&type=script&lang=ts"

import "./SendMailCompletelyPage.vue?vue&type=style&index=0&id=47b17339&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-47b17339"
/* hot reload */
if (module.hot) {
  script.__hmrId = "47b17339"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47b17339', script)) {
    api.reload('47b17339', script)
  }
  
  module.hot.accept("./SendMailCompletelyPage.vue?vue&type=template&id=47b17339&scoped=true", () => {
    api.rerender('47b17339', render)
  })

}

script.__file = "src/views/registerTeam/SendMailCompletelyPage.vue"

export default script